import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LayoutService } from '@wayout-admin/shell';
import { ConfirmationService, MessageService } from 'primeng/api';
import { definePreset } from '@primeuix/themes';
import { ENVIRONMENT } from '@wayout-admin/util';
import { environment } from '../environments/environment';
import { ConfirmationPopupService, MessagePopupService } from '@wayout-fe/util';
import { tokenInterceptor } from '@wayout-admin/data-access';
import localSr from '@angular/common/locales/sr-Latn'; // Example for French locale data
import { registerLocaleData } from '@angular/common';

registerLocaleData(localSr);
const MyPreset = definePreset(Aura, {
	semantic: {
		primary: {
			50: '{indigo.50}',
			100: '{indigo.100}',
			200: '{indigo.200}',
			300: '{indigo.300}',
			400: '{indigo.400}',
			500: '{indigo.500}',
			600: '{indigo.600}',
			700: '{indigo.700}',
			800: '{indigo.800}',
			900: '{indigo.900}',
			950: '{indigo.950}',
		},
	},
});

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(
			appRoutes,
			withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
			withEnabledBlockingInitialNavigation()
		),
		provideTranslateService({
			lang: 'sr',
			fallbackLang: 'sr',
			loader: provideTranslateHttpLoader({
				prefix: '/i18n/',
				suffix: '.json',
			}),
		}),
		provideHttpClient(withFetch(), withInterceptors([tokenInterceptor])),
		provideAnimationsAsync(),
		providePrimeNG({ theme: { preset: MyPreset, options: { darkModeSelector: '.app-dark' } } }),
		LayoutService,
		ConfirmationService,
		{ provide: ENVIRONMENT, useValue: environment },
		MessageService,
		MessagePopupService,
		ConfirmationPopupService,
		{
			provide: LOCALE_ID,
			useValue: 'sr-Latn',
		},
	],
};
